import { Injectable } from '@angular/core';
import { EncryptStorage } from 'encrypt-storage';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
class StorageService extends EncryptStorage {
    constructor() {
        super(environment.storageSecretKey, {
            prefix: 'cadreWeb',
            storageType: 'localStorage',
            encAlgorithm: 'AES',
            doNotEncryptValues: false
        });
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    constructor(private storageService: StorageService) {}

    set<T>(key: string, value: T) {
        this.storageService.setItem(this.storageService.hash(key), value);
    }

    get<T>(key: string) {
        return this.storageService.getItem<T>(this.storageService.hash(key));
    }

    remove(key: string) {
        return this.storageService.removeItem(this.storageService.hash(key));
    }

    clearStorage() {
        this.storageService.clear();
    }
}
